namespace Matrix.Visualizer {
    export class GraphColumns {
        static columnsKey = 'Visualizer.Graph';
    }
}
